import { AfterViewInit, Component, Input, OnInit, OnDestroy, Renderer2, ElementRef, ViewChild } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { Subscription } from 'rxjs';
import { EventService } from 'src/app/core/services/event.service';
import { DevelopmentsService } from '../../../services/developments.services';
import { PermissionsService } from 'src/app/core/services/permissions.service';

@Component({
  selector: 'app-areas-nearby-developments',
  templateUrl: './areas-nearby.component.html',
  styleUrls: ['./areas-nearby.component.scss']
})
export class AreasNearbyDevelopmentsComponent implements OnInit, AfterViewInit, OnDestroy {
  @Input()
  propertyAreasNearbyData: any
  @Input()
  submitted: boolean = false;
  @Input()
  dataToFormInit: any
  @Input() detailsForm: any;
  @Input() dataToFormInitDetails: any

  subscriptionSubmitted!: Subscription;
  selectValueNumber = Array.from({ length: 300 }, (_, i) => i + 1);
  propertyAreasNearbyForm!: FormGroup;
  isBuildingImplantationArea = false;
  @ViewChild('formElementRef') formElementRef!: ElementRef;
  @Input()
  property: any;


  constructor(
    private eventService: EventService, 
    private formBuilder: FormBuilder, 
    private renderer: Renderer2, 
    private propertiesService: DevelopmentsService,
    private permissionsService: PermissionsService
  ) { }


  ngOnInit(): void {
    const propertyType = this.dataToFormInitDetails?.propertyTypes.find((s: any) => s.id === this.detailsForm?.data?.propertyType && s?.keyGroup === 'Land');
    if (propertyType) {
      this.isBuildingImplantationArea = true;
    }
    this.initFormValidation();
  }

  ngAfterViewInit(): void {

    this.subscriptionSubmitted = this.eventService.subscribe('get-data-tab-areas-nearby-dev', () => {
      this.propertyAreasNearbyData.data = this.propertyAreasNearbyForm.value;
      this.propertyAreasNearbyData.errors = this.getFormErrors();
      this.propertyAreasNearbyData.valid = this.propertyAreasNearbyForm.valid;
    });
    this.setEletemtConfig();
  }

  /**
* Form data get
*/
  get form() {
    return this.propertyAreasNearbyForm.controls;
  }
  /**
  * Form Validation
*/
  initFormValidation() {
    this.dynamicDataForm();
    this.propertyAreasNearbyForm = this.formBuilder.group(this.propertyAreasNearbyData.data);
  }

  dynamicDataForm() {

    if (this.propertyAreasNearbyData === undefined || this.propertyAreasNearbyData === null)
      this.propertyAreasNearbyData = { data: {} };
    this.propertyAreasNearbyData.data[`usefulArea`] = [this.propertyAreasNearbyData?.data?.usefulArea ? this.propertyAreasNearbyData?.data?.usefulArea : 0];
    this.propertyAreasNearbyData.data[`grossArea`] = [this.propertyAreasNearbyData?.data?.grossArea ? this.propertyAreasNearbyData?.data?.grossArea : 0];
    this.propertyAreasNearbyData.data[`grossDependentArea`] = [this.propertyAreasNearbyData?.data?.grossDependentArea ? this.propertyAreasNearbyData?.data?.grossDependentArea : 0];
    this.propertyAreasNearbyData.data[`grossPrivateArea`] = [this.propertyAreasNearbyData?.data?.grossPrivateArea ? this.propertyAreasNearbyData?.data?.grossPrivateArea : 0];
    this.propertyAreasNearbyData.data[`landArea`] = [this.propertyAreasNearbyData?.data?.landArea ? this.propertyAreasNearbyData?.data?.landArea : 0];
    this.propertyAreasNearbyData.data[`buildingImplantationArea`] = [this.propertyAreasNearbyData?.data?.buildingImplantationArea
      ? this.propertyAreasNearbyData?.data?.buildingImplantationArea : 0];

    this.propertyAreasNearbyData.data[`hideUsefulArea`] = [
      this.propertyAreasNearbyData?.data?.hideUsefulArea === true ? this.propertyAreasNearbyData?.data?.hideUsefulArea : false
    ];
    this.propertyAreasNearbyData.data[`hideGrossArea`] = [
      this.propertyAreasNearbyData?.data?.hideGrossArea === true ? this.propertyAreasNearbyData?.data?.hideGrossArea : false
    ];
    this.propertyAreasNearbyData.data[`hideGrossDependentArea`] = [
      this.propertyAreasNearbyData?.data?.hideGrossDependentArea === true ? this.propertyAreasNearbyData?.data?.hideGrossDependentArea : false
    ];
    this.propertyAreasNearbyData.data[`hideGrossPrivateArea`] = [
      this.propertyAreasNearbyData?.data?.hideGrossPrivateArea === true ? this.propertyAreasNearbyData?.data?.hideGrossPrivateArea : false
    ];
    this.propertyAreasNearbyData.data[`hideLandArea`] = [
      this.propertyAreasNearbyData?.data?.hideLandArea === true ? this.propertyAreasNearbyData?.data?.hideLandArea : false
    ];
    this.propertyAreasNearbyData.data[`hideBuildingImplantationArea`] = [
      this.propertyAreasNearbyData?.data?.hideBuildingImplantationArea === true ? this.propertyAreasNearbyData?.data?.hideBuildingImplantationArea : false
    ];

    for (let d of this.dataToFormInit.divisions) {
      this.propertyAreasNearbyData.data[`division${d.division.id}`] = [this.propertyAreasNearbyData.data[`division${d.division.id}`]
        ? this.propertyAreasNearbyData.data[`division${d.division.id}`] : 0];

      this.propertyAreasNearbyData.data[`hideDivision${d.division.id}`] = [
        this.propertyAreasNearbyData.data[`hideDivision${d.division.id}`] === true ? this.propertyAreasNearbyData.data[`hideDivision${d.division.id}`] : false
      ];
    }

    for (let n of this.dataToFormInit.nearby) {

      this.propertyAreasNearbyData.data[`nearby${n.nearby.id}`] = [this.propertyAreasNearbyData.data[`nearby${n.nearby.id}`]];
      this.propertyAreasNearbyData.data[`valNearby-${n.nearby.id}`] = [this.propertyAreasNearbyData.data[`valNearby-${n.nearby.id}`]];
      this.propertyAreasNearbyData.data[`unitNearBy-${n.nearby.id}`] = [this.propertyAreasNearbyData.data[`unitNearBy-${n.nearby.id}`]
        ? this.propertyAreasNearbyData.data[`unitNearBy-${n.nearby.id}`] : this.dataToFormInit.units[0].id];

      this.propertyAreasNearbyData.data[`hideNearby${n.nearby.id}`] = [
        this.propertyAreasNearbyData.data[`hideNearby${n.nearby.id}`] === true ? this.propertyAreasNearbyData.data[`hideNearby${n.nearby.id}`] : false
      ];
    }

  }

  getFormErrors(): [] {
    let errors: any = [];
    Object.keys(this.propertyAreasNearbyForm.controls).forEach(key => {
      // Get errors of every form control
      let type = this.propertyAreasNearbyForm?.get(key)?.errors;
      if (type)
        errors.push({ key: key, type: type });
    });
    return errors;
  }

  increment(division: any) {
    let val = this.propertyAreasNearbyForm.get(`division${division.id}`)?.value;
    if (val < 300) {
      val++;
      const data1: any = {};
      data1[`division${division.id}`] = val;
      this.propertyAreasNearbyForm.patchValue(data1);
      this.propertyAreasNearbyForm.addControl(`areaInput-${division.id}-${val}`, this.formBuilder.control(''));
      const data2: any = {};
      data2[`areaInput-${division.id}-${val}`] = 0;
      this.propertyAreasNearbyForm.patchValue(data2);
    }
    for (let i = 0; i < val; i++) { }
  }
  decrement(division: any) {

    let val = this.propertyAreasNearbyForm.get(`division${division.id}`)?.value;
    if (val > 0) {
      this.propertyAreasNearbyForm.removeControl(`areaInput-${division.id}-${val}`);
      val--;
      const data1: any = {};
      data1[`division${division.id}`] = val;
      this.propertyAreasNearbyForm.patchValue(data1);
    }
  }

  deleteAreaDivision(division: any, areaInput: any) {
    let data: any = [];
    let val = this.propertyAreasNearbyForm.get(`division${division.id}`)?.value;
    for (let i = 1; i <= val; i++) {
      const val2 = this.propertyAreasNearbyForm.get(`areaInput-${division.id}-${i}`)?.value;
      if (`areaInput-${division.id}-${i}` !== areaInput) {
        data.push(val2)
      }
      this.propertyAreasNearbyForm.removeControl(`areaInput-${division.id}-${i}`);
    }
    val--;
    if (val === 0) {
      const data1: any = {};
      data1[`division${division.id}`] = val;
      this.propertyAreasNearbyForm.patchValue(data1);
    }
    for (let i = 0; i < data.length; i++) {
      const data1: any = {};
      data1[`division${division.id}`] = val;
      this.propertyAreasNearbyForm.patchValue(data1);
      this.propertyAreasNearbyForm.addControl(`areaInput-${division.id}-${i + 1}`, this.formBuilder.control(''));
      const data2: any = {};
      data2[`areaInput-${division.id}-${i + 1}`] = data[i];
      this.propertyAreasNearbyForm.patchValue(data2);
    }
  }

  setEletemtConfig() {
    if (!this.permissionsService.checkMasterPermission('EDIT_PROPERTIES', this.property?.store?.id) && !this.permissionsService.checkAgentPermission(this.property?.mainAgent, 'EDIT_PROPERTIES') && this.property) {
      if (this.formElementRef.nativeElement) {
        this.renderer.setStyle(this.formElementRef.nativeElement, 'pointer-events', 'none')
        const parentElement = this.formElementRef.nativeElement.parentElement;
        if (parentElement)
          this.renderer.setStyle(parentElement, 'cursor', 'not-allowed')
      }
    }
  }

  ngOnDestroy(): void {
    this.propertyAreasNearbyData.data = this.propertyAreasNearbyForm.value;
    this.propertyAreasNearbyData.errors = this.getFormErrors();
    this.propertyAreasNearbyData.valid = this.propertyAreasNearbyForm.valid;
    this.subscriptionSubmitted.unsubscribe();
  }
}
